import {
  ImApplication,
  CatalogSlumpsResponse,
  ImSpacing,
  ImUnloadTime,
  ImUnloadType,
  ImSlump,
  ImLoadSize,
  TechnicalProductOP,
  IShipmentLocation,
} from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import { TemperatureFeatures } from '../../../../shared/services/experiences.service';
import { CatalogPumpCapacitiesResponse, ImFeature } from '@cemex-core/cmx-api/models/catalogs/catalogs-response';

export enum SingleCatalogsActionTypes {
  LOAD_APPLICATION = '[Application] Load',
  LOAD_APPLICATION_COMPLETED = '[Application] Load complete',
  ADD_APPLICATION = '[Application] Add application item',
  LOAD_SPACING = '[Spacing] Load',
  LOAD_SPACING_COMPLETED = '[Spacing] Load complete',
  LOAD_UNLOAD_TIME = '[Unload Time] Load',
  LOAD_UNLOAD_TIME_COMPLETED = '[Unload Time] Load complete',
  LOAD_UNLOAD_TIME_FILTERED = '[Unload Time] Load filtered values',
  LOAD_UNLOAD_TIME_FILTERED_COMPLETED = '[Unload Time] Load filtered values complete',
  ADD_LOCAL_UNLOAD_TIME = '[Spacing] Add local unload time.',
  LOAD_UNLOAD_TYPE = '[Unload Type] Load',
  LOAD_PUMP_CAPACITY = '[Pump Capacity] Load',
  LOAD_PUMP_CAPACITY_SUCCESS = '[RMS PumpCapacities] Available Pump Capacities Success',
  ADD_UNLOAD_TYPE = '[Unload Type] Add unloadtype item',
  LOAD_UNLOAD_TYPE_PLANT = '[Unload Type] Load plant catalog',
  LOAD_UNLOAD_TYPE_COMPLETED = '[Unload Type] Load complete',
  LOAD_UNLOAD_TYPE_FILTERED = '[Unload Type] Load filtered complete',
  CHANGE_UNLOAD_TIME = '[Unload Time] change',
  CHANGE_UNLOAD_TIME_COMPLETE = '[Unload Time] change complete',
  LOAD_SLUMP = '[Slump] Load',
  LOAD_SLUMP_FILTERED = '[Slump] Load filtered',
  LOAD_PUMPABILITIES = '[Pumpability] Load',
  LOAD_PUMPABILITY_FILTERED = '[Pumpability] Load filtered',
  LOAD_SLUMP_COMPLETED = '[Slump] Load complete',
  LOAD_SLUMP_PRODUCT = '[Slump product] Load',
  LOAD_SLUMP_PRODUCT_COMPLETED = '[Slump product] Load complete',
  LOAD_LOAD_SIZE = '[Load size] Load',
  LOAD_LOAD_SIZE_COMPLETED = '[Load size] Load complete',
  LOAD_TEMPERATURE = '[Temperature] Load',
  LOAD_TEMPERATURE_COMPLETED = '[Temperature] Load complete',
  ADD_LOCAL_SPACINGS = '[Spacing] Add local value spacing.',
  CATALOG_COMPLETE = '[Catalog] Complete',
  RESET = '[SingleCatalogs] Reset',
  ERROR = '[SingleCatalogs] Error',
  ADD_LOCAL_TEMPERATURE = '[Temperature] Add local value Temperature.',
  UPDATE_LOAD_SIZES = '[Load Sizes] Update Load Sizes',
  RESET_LOAD_SIZES = '[Load Sizes] Reset Load Sizes',
}

export class LoadApplicationCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_APPLICATION;

  constructor() {}
}

export class LoadApplicationCatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_APPLICATION_COMPLETED;

  constructor(public payload: ImApplication[]) {}
}

export class AddApplicationCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.ADD_APPLICATION;

  constructor(public payload: ImApplication) {}
}

export class LoadSpacingCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_SPACING;

  constructor() {}
}

export class AddLocalUnloadTimesCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.ADD_LOCAL_UNLOAD_TIME;

  constructor(public payload: ImUnloadTime[]) {}
}
export class ChangeUnloadTimeAction implements Action {
  readonly type = SingleCatalogsActionTypes.CHANGE_UNLOAD_TIME;

  constructor(public payload: number) {}
}
export class ChangeUnloadTimeCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.CHANGE_UNLOAD_TIME_COMPLETE;

  constructor(public payload: ImSpacing[]) {}
}

export class LoadSpacingCatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_SPACING_COMPLETED;

  constructor(public payload: ImSpacing[]) {}
}

export class AddLocalSpacingsCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.ADD_LOCAL_SPACINGS;

  constructor(public payload: ImSpacing[]) {}
}

export class LoadUnloadTimeCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_UNLOAD_TIME;

  constructor() {}
}

export class LoadUnloadTimeCatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_UNLOAD_TIME_COMPLETED;

  constructor(public payload: { unloadTimes: ImUnloadTime[]; filteredUnloadTimes: ImUnloadTime[] }) {}
}

export class LoadUnloadTimeFilteredCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_UNLOAD_TIME_FILTERED;

  constructor(public payload: string) {}
}

export class LoadUnloadTimeFilteredCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_UNLOAD_TIME_FILTERED_COMPLETED;

  constructor(public payload: ImUnloadTime[]) {}
}

export class LoadUnloadTypeCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_UNLOAD_TYPE;

  constructor() {}
}

export class LoadPumpCapacityAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_PUMP_CAPACITY;

  constructor() {}
}

export class LoadAvailablePumpCapacitiesSuccessAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_PUMP_CAPACITY_SUCCESS;
  constructor(public payload: CatalogPumpCapacitiesResponse) {}
}

export class LoadUnloadTypePlantCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_UNLOAD_TYPE_PLANT;

  constructor() {}
}

export class LoadUnloadTypeCatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_UNLOAD_TYPE_COMPLETED;

  constructor(public payload: ImUnloadType[]) {}
}

export class LoadUnloadTypeFilteredCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_UNLOAD_TYPE_FILTERED;

  constructor(public payload: ImUnloadType[]) {}
}

export class AddUnloadTypeFilteredCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.ADD_UNLOAD_TYPE;

  constructor(public payload: ImUnloadType[]) {}
}

export class LoadSlumpCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_SLUMP;

  constructor(public payload?: { productCode: string }) {}
}

export class LoadSlumpFilteredCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_SLUMP_FILTERED;

  constructor(public payload: TechnicalProductOP[]) {}
}

export class LoadPumpabilityCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_PUMPABILITIES;

  constructor() {}
}

export class LoadPumpabilityFilteredCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_PUMPABILITY_FILTERED;

  constructor(public payload: { id: number; name: string }[]) {}
}

export class LoadSlumpCatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_SLUMP_COMPLETED;

  constructor(public payload: ImSlump[]) {}
}

export class LoadSlumpProductCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_SLUMP_PRODUCT;

  constructor(public payload?: { productCode: string }) {}
}

export class LoadSlumpProductCatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_SLUMP_PRODUCT_COMPLETED;

  constructor(
    public payload: {
      [productCode: string]: CatalogSlumpsResponse;
    },
  ) {}
}

export class LoadLoadSizeCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_LOAD_SIZE;

  constructor() {}
}

export class LoadLoadSizeCatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_LOAD_SIZE_COMPLETED;

  constructor(public payload: ImLoadSize[]) {}
}

export class SingleCatalogsResetAction implements Action {
  readonly type = SingleCatalogsActionTypes.RESET;

  constructor() {}
}

export class SingleCatalogsErrorAction implements Action {
  readonly type = SingleCatalogsActionTypes.ERROR;

  constructor(public payload: any) {}
}

export class CatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.CATALOG_COMPLETE;
  constructor() {}
}

export class LoadTemperatureCatalogAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_TEMPERATURE;

  constructor(
    public payload: {
      feature: TemperatureFeatures;
      jobsite: IShipmentLocation;
    },
  ) {}
}
export class LoadTemperatureCatalogCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.LOAD_TEMPERATURE_COMPLETED;

  constructor(public payload: any[]) {}
}
export class AddLocalTemperatureCompleteAction implements Action {
  readonly type = SingleCatalogsActionTypes.ADD_LOCAL_TEMPERATURE;

  constructor(public payload: ImFeature[]) {}
}

export class UpdateLoadSizes implements Action {
  readonly type = SingleCatalogsActionTypes.UPDATE_LOAD_SIZES;

  constructor(public payload: ImLoadSize[]) {}
}

export class ResetLoadSizes implements Action {
  readonly type = SingleCatalogsActionTypes.RESET_LOAD_SIZES;

  constructor() {}
}

export type SingleCatalogsActions =
  | LoadApplicationCatalogAction
  | LoadApplicationCatalogCompleteAction
  | LoadSpacingCatalogAction
  | LoadSpacingCatalogCompleteAction
  | LoadUnloadTimeCatalogAction
  | LoadUnloadTimeCatalogCompleteAction
  | LoadUnloadTimeFilteredCatalogAction
  | LoadUnloadTimeFilteredCompleteAction
  | LoadUnloadTypeCatalogAction
  | LoadPumpCapacityAction
  | LoadAvailablePumpCapacitiesSuccessAction
  | LoadUnloadTypePlantCatalogAction
  | LoadUnloadTypeCatalogCompleteAction
  | LoadUnloadTypeFilteredCompleteAction
  | LoadSlumpCatalogAction
  | LoadSlumpCatalogCompleteAction
  | LoadSlumpProductCatalogAction
  | LoadSlumpProductCatalogCompleteAction
  | LoadPumpabilityCatalogAction
  | LoadPumpabilityFilteredCatalogAction
  | LoadLoadSizeCatalogAction
  | LoadLoadSizeCatalogCompleteAction
  | SingleCatalogsResetAction
  | ChangeUnloadTimeAction
  | ChangeUnloadTimeCompleteAction
  | SingleCatalogsErrorAction
  | AddLocalUnloadTimesCompleteAction
  | AddUnloadTypeFilteredCompleteAction
  | AddApplicationCatalogAction
  | AddLocalSpacingsCompleteAction
  | LoadTemperatureCatalogAction
  | LoadTemperatureCatalogCompleteAction
  | AddLocalTemperatureCompleteAction
  | UpdateLoadSizes
  | ResetLoadSizes;
